import {
	Box,
	Heading,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Text,
	useBreakpointValue,
	chakra,
	Flex,
} from "@chakra-ui/react";
import RecentCheckItem from './RecentCheckItem';
import { RepeatIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";

const RecentChecksList = ({ onSelectAddress, onClear, onSelectAddresses, isUserHasKey }) => {
	const [recentChecks, setRecentChecks] = useState([]);
	const [sortDirection, setSortDirection] = useState("desc"); // Default sort direction
	const isMobile = useBreakpointValue({ base: true, md: false });

	useEffect(() => {
		// Load recent checks from localStorage on component mount
		const storedChecks = localStorage.getItem('recentChecks');
		if (storedChecks) {
			setRecentChecks(JSON.parse(storedChecks));
		}
	}, []);

	const handleClearRecentChecks = () => {
		localStorage.removeItem('recentChecks');
		setRecentChecks([]); // Clear the state
	};

	const handleAllRecent = () => {
		const recentMarksData = localStorage.getItem('recentChecks');

		if (recentMarksData) {
			try {
				const recentChecks = JSON.parse(recentMarksData);
				const addresses = recentChecks.map(item => item.address);
				const addressesString = addresses.join('\n');
				onSelectAddresses(addressesString);
			} catch (error) {
				console.error('Error parsing recentChecks data:', error);
			}
		} else {
			console.log('No recentChecks data found in localStorage');
		}
	};

	const handleDelete = (address) => {
		const updatedChecks = recentChecks.filter(check => check.address !== address);
		localStorage.setItem('recentChecks', JSON.stringify(updatedChecks));
		setRecentChecks(updatedChecks); // Update the state to trigger re-render
	};

	// Sort recent checks based on marks and direction
	const sortedRecentChecks = [...recentChecks].sort((a, b) => {
		return sortDirection === "asc" ? a.marks - b.marks : b.marks - a.marks; // Sort by marks
	});

	const toggleSortDirection = () => {
		setSortDirection(sortDirection === "asc" ? "desc" : "asc"); // Toggle direction
	};

	return (
		sortedRecentChecks.length > 0 && (
			<Box mt={12}>
				<Heading size="md" mb={6} textAlign={"center"}>
					Recent Checks {isUserHasKey && <chakra.span pl='8px' color={"#FF684B"}><RepeatIcon onClick={handleAllRecent} cursor={"pointer"} /></chakra.span>}
				</Heading>

				<Box overflowX="auto"> {/* Контейнер для горизонтальной прокрутки */}
					<Table variant="simple" size={"sm"}>
						<Thead background={"gray.100"}>
							<Tr>
								<Th>Address</Th>
								<Th textAlign="center">Rank</Th>
								<Th textAlign="center" onClick={toggleSortDirection} cursor="pointer">
									<Flex flexFlow={"row"} gap={2}>
										<chakra.span>Marks</chakra.span>
										{sortDirection === "asc" ? '↑' : '↓'}
									</Flex>
								</Th>
								<Th textAlign="center">{isMobile ? 'Top' : 'Percentage'}</Th>
								<Th textAlign="center">
									{isMobile ? 'Updated' : 'Date Updated'}
								</Th>
								<Th />
							</Tr>
						</Thead>
						<Tbody>
							{sortedRecentChecks.map((check, index) => (
								<RecentCheckItem key={index} check={check} onClick={onSelectAddress} onDelete={handleDelete} />
							))}
						</Tbody>
					</Table>
				</Box>
				<Text
					mt={4}
					onClick={handleClearRecentChecks}
					textAlign={"center"}
					cursor={"pointer"}
					color="#FF684B"
					fontSize="md"
					_hover={{
						textDecoration: "underline",
					}}
				>
					Clear all data
				</Text>
			</Box>
		)
	);
};

export default RecentChecksList;
